// Shared formatting for integration log rows — used by both the
// per-integration card (Settings → Integrations) and the central
// Data → Logs table. Keep the two views visually consistent.

/** Tailwind text-color class for an integration-log status. */
export function logStatusColor(status: string): string {
  return status === "ok" ? "text-good"
    : status === "error" ? "text-bad"
      : "text-muted-foreground";
}

export function formatDuration(durationMs: number | null): string {
  if (durationMs === null) return "—";
  return durationMs < 1000 ? `${String(durationMs)}ms` : `${(durationMs / 1000).toFixed(1)}s`;
}
